enum ActionTypes {
  RESET_SEARCH="RESET_SEARCH",
  TOGGLE_SIDEBAR_FIRSTPART= "TOGGLE_SIDEBAR_FIRSTPART",
  TOGGLE_SIDEBAR_SECONDPART= "TOGGLE_SIDEBAR_SECONDPART",
  TOGGLE_SIDEBAR_PROCESSING_PARAMS= "TOGGLE_SIDEBAR_PROCESSING_PARAMS",
  SET_ACTIVE_TAB_ON_LEFT_SIDEBAR= "SET_ACTIVE_TAB_ON_LEFT_SIDEBAR",
  STORE_INITIAL_DATA_STARTED= "STORE_INITIAL_DATA_STARTED",
  STORE_INITIAL_DATA_SUCCESS= "STORE_INITIAL_DATA_SUCCESS",
  SET_MISSION= "SET_MISSION",
  SET_MULTI_MISSION="SET_MULTI_MISSION",
  SET_APPLICATION_ERROR= "SET_APPLICATION_ERROR",
  TOGGLE_PRODUCT_CATEGORY_FLAG= "TOGGLE_PRODUCT_CATEGORY_FLAG",
  STORE_SEARCH_RESULT_DETAILS= "STORE_SEARCH_RESULT_DETAILS",
  REMOVE_SEARCH_RESULT_DETAILS= "REMOVE_SEARCH_RESULT_DETAILS",
  SHOW_PRODUCT_DETAILS= "SHOW_PRODUCT_DETAILS",
  HIDE_PRODUCT_DETAILS= "HIDE_PRODUCT_DETAILS",
  STORE_FORMDATA_PAYLOAD= "STORE_FORMDATA_PAYLOAD",
  UPDATE_FORMDATA_PAYLOAD= "UPDATE_FORMDATA_PAYLOAD",
  RESET_SEARCH_FILTERS_SELECTED="RESET_SEARCH_FILTERS_SELECTED",
  UPDATE_SEARCH_FILTERS_SELECTED= "UPDATE_SEARCH_FILTERS_SELECTED",
  INIT_PROCESS_FILTERS_SELECTED="INIT_PROCESS_FILTERS_SELECTED",
  UPDATE_PROCESS_FILTERS_SELECTED= "UPDATE_PROCESS_FILTERS_SELECTED",
  CHANGE_ROUTINE_STATUS= "CHANGE_ROUTINE_STATUS",
  SET_APP_PARAMETERS= "SET_APP_PARAMETERS",
  SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
  SET_CURRENT_MASTER_ITEM = "SET_CURRENT_MASTER_ITEM",
  RESET_PRODUCTION_FILTERS_SELECTED = "RESET_PRODUCTION_FILTERS_SELECTED",
  UPDATE_PRODUCTION_FILTERS_SELECTED = "UPDATE_PRODUCTION_FILTERS_SELECTED"
};
export default ActionTypes;
